require('./brokerHireInvestmentFundSuccess.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');
const momentTz = require('moment-timezone');
// @ components
const BrokerHireInvestmentFundDetails = require('../brokerHireInvestmentFundDetails/brokerHireInvestmentFundDetails');
// @ commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ constants
const { DATE_FORMAT_COMPLETE, BROKER_MYPROFILE_MYWALLET_URL } = require('constants/index');
const { catalogue, analyticsId } = require('../analytics/brokerHireInvestmentFund.tracking');
// @ utilities
const { recordLinkV2 } = require("utilities/tagging");

class BrokerHireInvestmentFundSuccess extends React.Component {

    componentDidMount() {
        recordLinkV2(catalogue[analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_2_SUCCESS]());
    }

    buildColumns() {
        const { immInvestmentFunds, immFlagBasedFeatures } = this.props;
        const baseColumns = ['account', 'brokerHireInvestmentSuccess-amount'];
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        const ffContribution = immFlagBasedFeatures.get('wealth_funds_periodic_contributions');
        if (ffContribution && !isSubscription) {
            baseColumns.push('contribution');
        }
        let columns;
        if (isSubscription) {
            columns = [
                'brokerHireInvestmentSuccess-aplicationDate',
                'brokerHireInvestmentSuccess-subscriptionFund',
                ...baseColumns
            ];
        } else {
            columns = [
                'brokerHireInvestmentSuccess-date',
                'brokerHireInvestmentSuccess-destinationFund',
                ...baseColumns
            ];
        }
        return columns;
    }

    buildMessage() {
        const { immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            return formatText('brokerHireInvestmentSuccess-successMessageSubs');
        } else {
            return formatText('brokerHireInvestmentSuccess-successMessage');
        }
    }

    render() {
        const { immInvestmentFunds, immAccounts, immFlagBasedFeatures, immBrokerMyInvestments } = this.props;
        const fundName = immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'name']);
        const accountNumber = immInvestmentFunds.getIn(['steps', 0, 'accountNumber']);
        const immAccount = immAccounts.get(accountNumber);
        const currencyObject = {
            amount: immInvestmentFunds.getIn(['steps', 0, 'amount']),
            currency: immAccount.getIn(['balance', 'currency']) //TODO: Cambiar el codigo de moneda según el fondo
        };
        const amountInvestment = getFormattedString(currencyObject);
        let columnsContent = [
            momentTz().tz("Europe/Madrid").format(DATE_FORMAT_COMPLETE),
            fundName,
            'account',
            amountInvestment
        ];
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            const liquidAmount = immInvestmentFunds.getIn(['subscriptionFund', 'liquidAmount']);
            const liquidAmountText = getFormattedString(liquidAmount);
            columnsContent.push(liquidAmountText);
        }

        const columns = this.buildColumns();
        const successMessage = this.buildMessage();

        return (
            <div className="hire-investment-success">
                <WizardSuccess
                    customClassName="hire-investment-success__container"
                    successMessage={successMessage}
                    processDetail={immInvestmentFunds.getIn(['investmentFunds', 'isin'])}
                    tealium={catalogue[analyticsId.BROKER_HIRE_INVESTMENT_FUND_SUCCESS]({
                        productName: immInvestmentFunds.getIn(['investmentFunds', 'isin']),
                    })}
                >
                    <div className="account-debits-return-success__actions text-right" />
                </WizardSuccess>
                <div className="hire-investment-success__details">
                    <FormattedText value="brokerHireInvestmentSuccess-details" />
                </div>
                <BrokerHireInvestmentFundDetails
                    columns={columns}
                    columnsContent={columnsContent}
                    immAccount={immAccount}
                    immInvestmentFunds={immInvestmentFunds}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immBrokerMyInvestments={immBrokerMyInvestments}
                />
                <div className="hire-investment-success__buttons">
                    <div className="hire-investment-success__div-buttons-right">
                        <div className="hire-investment-success__left-button">
                            <OKButton
                                modifier="ghost"
                                to={BROKER_MYPROFILE_MYWALLET_URL + '/ordersAndMovements'}
                            >
                                <FormattedText value="brokerHireInvestmentSuccess-askMovements" />
                            </OKButton>
                        </div>
                        <OKButton
                            modifier="secondary"
                            to={BROKER_MYPROFILE_MYWALLET_URL}
                        >
                            <FormattedText value="brokerHireInvestmentSuccess-finish" />
                        </OKButton>
                    </div>
                    <div className="clearfix" />
                </div>
            </div>
        );
    }
}

BrokerHireInvestmentFundSuccess.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = BrokerHireInvestmentFundSuccess;
